import axios from "axios";
import { GET_ALL_ACHIEVEMENTS } from "./types";
const keys = require("../config/keys");

export const getAllAchievements = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionForm/GetAllAchievements"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_ACHIEVEMENTS,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAllAchievements.js